export const termsContent = [
  {
    index: 1,
    title: "Our Services",
    content: "Our Services provide website analysis to help improve user engagement and conversion rates. The information provided on or through the Services is for informational purposes and is not intended for distribution in any jurisdiction or country where such use would be illegal or would subject us to registration requirements."
  },
  {
    index: 2,
    title: "Intellectual Property Rights",
    content: "All intellectual property rights in our Services, including all code, databases, functionality, software, designs, text, graphics, and logos (collectively, the 'Content') are owned by or licensed to us. You are granted a limited license to access and use the Services for your personal or internal business purposes."
  },
  {
    index: 3,
    title: "User Representations",
    content: [
      "All registration information you submit is accurate.",
      "You will keep this information updated.",
      "You have the legal capacity to comply with these Terms.",
      "You are at least 18 years old.",
      "You will not use the Services for any illegal purposes."
    ]
  },
  {
    index: 4,
    title: "User Registration",
    content: "You may be required to register to use certain features of the Services. You agree to keep your login credentials confidential. We reserve the right to change or reclaim any username we find inappropriate."
  },
  {
    index: 5,
    title: "Purchases and Payment",
    content: "You agree to provide current, complete, and accurate purchase and account information for all purchases made via the Services. We may change prices and reserve the right to correct any errors in pricing. All payments are processed in USD."
  }
];